<script lang="ts">
	import { clickoutside } from "@svelte-put/clickoutside";
	import { onMount } from "svelte";

	import type { PageData } from "./$types";

	import { PUBLIC_ENV } from "$env/static/public";
	import Cookies from "$lib/components/singulars/Cookies.svelte";
	import Install from "$lib/components/singulars/install/Install.svelte";
	import Prompt from "$lib/components/singulars/install/Prompt.svelte";
	import Footer from "$lib/components/wrappers/Footer.svelte";
	import { t } from "$lib/translations";


	export let data: PageData;

	let mobileDropdown: HTMLElement;
	let header: HTMLElement;
	let mobileToggle: SVGSVGElement;
	let parent: HTMLElement;
	let mobileDropdownIstoggled = false;

	const toggleMobileDropdown = () => {
		mobileDropdown.classList.toggle("hidden");
		mobileToggle.classList.toggle("active");
		mobileDropdownIstoggled = !mobileDropdownIstoggled;
	};

	onMount(() => {
		let lastScroll = 0;
		window.addEventListener("scroll", () => {
			const currentScroll = window.scrollY;
			if (!header) return;
			if (currentScroll <= 0) {
				header.style.top = "0";
				header.style.transition = "top 0.3s";
			} else if (currentScroll > lastScroll) {
				header.style.top = "-100px";
				header.style.transition = "top 0.3s";
			} else {
				header.style.top = "0";
				header.style.transition = "top 0.3s";
			}
			lastScroll = currentScroll;
		});
	});

	$: mobileDropdown, mobileToggle, mobileDropdownIstoggled;
</script>

<svelte:head>
	<title>{$t("landing.title")}</title>
</svelte:head>

<div class="bg-tan-50" bind:this={parent}>
	<header class="sticky py-0.5 inset-x-0 top-0 z-50 bg-tan-50 bg-opacity-90" bind:this={header}>
		<nav class="mx-4 mt-4 flex justify-between">
			<div class="flex items-center">
				<a href="{data.lang == 'fr' ? '/fr' : ''}/">
					<img class="h-12 w-12" src="/logo.png" alt="logo" />
				</a>
				<a
					href="{data.lang == 'fr' ? '/fr' : ''}/features"
					class="text-gray-500 font-normal text-sm ml-8 md:hidden">Features</a
				>
				<div class="ml-8 hidden md:flex space-x-6 items-center">
					<a
						href="{data.lang == 'fr' ? '/fr' : ''}/features"
						class="text-gray-500 font-normal text-sm">Features</a
					>
					<!-- <a href="{data.lang == 'fr' ? '/fr' : ''}/recipes" class="text-gray-500 font-normal text-sm">Recipes</a> -->
					<a
						href="{data.lang == 'fr' ? '/fr' : ''}/for-creators"
						class="text-gray-500 font-normal text-sm">For Creators</a
					>
					<a
						href="{data.lang == 'fr' ? '/fr' : ''}/pricing"
						class="text-gray-500 font-normal text-sm">Pricing</a
					>
					<a
						href="{data.lang == 'fr' ? '/fr' : ''}/essentials"
						class="text-gray-500 font-normal text-sm">Essentials</a
					>
					<!-- <a href="{data.lang == 'fr' ? '/fr' : ''}/blog" class="text-gray-500 font-normal text-sm">Blog</a> -->
					<a href="{data.lang == 'fr' ? '/fr' : ''}/about" class="text-gray-500 font-normal text-sm"
						>About</a
					>
				</div>
			</div>
			<div class="space-x-4 items-center flex">
				<!-- <Language lang={data.lang} scope="/" /> -->
				<!-- <a href="{data.lang == 'fr' ? '/fr' : ''}/login" class="text-gray-600 font-medium"
					>Sign In</a
				>
				<a
					href="{data.lang == 'fr' ? '/fr' : ''}/register"
					class="block w-fit rounded-full bg-opal p-2 text-sm font-medium text-white shadow-sm hover:bg-opal-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
					>Get Started</a
				>
				<div class="hidden md:block">
					<Install />
				</div> -->
				<button
					type="button"
					class="block md:hidden"
					on:click={(e) => {
						e.stopPropagation();
						toggleMobileDropdown();
					}}
				>
					<svg
						class="ham hamRotate ham1 text-gray-400"
						viewBox="0 0 100 100"
						width="40"
						bind:this={mobileToggle}
					>
						<path
							class="line top"
							d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"
						/>
						<path class="line middle" d="m 30,50 h 40" />
						<path
							class="line bottom"
							d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"
						/>
					</svg>
				</button>
			</div>

			<div
				bind:this={mobileDropdown}
				class="hidden show-dropdown absolute z-10 right-4 mt-16 w-64 origin-top-right rounded-xl bg-white py-1 shadow-lg ring-0 focus:ring-0 focus:outline-none"
				role="menu"
				aria-orientation="vertical"
				aria-labelledby="user-menu-button"
				use:clickoutside={{ limit: { parent }, enabled: mobileDropdownIstoggled }}
				on:clickoutside={toggleMobileDropdown}
			>
				<div class="flex flex-col space-y-4 p-4">
					<a
						on:click={() => toggleMobileDropdown()}
						href="{data.lang == 'fr' ? '/fr' : ''}/features"
						class="text-gray-600 font-medium text-base">Features</a
					>
					<!-- <a on:click={() => toggleMobileDropdown()} href="{data.lang == 'fr' ? '/fr' : ''}/recipes" class="text-gray-500 font-normal text-sm">Recipes</a> -->
					<a
						on:click={() => toggleMobileDropdown()}
						href="{data.lang == 'fr' ? '/fr' : ''}/for-creators"
						class="text-gray-600 font-medium text-base">For Creators</a
					>
					<a
						on:click={() => toggleMobileDropdown()}
						href="{data.lang == 'fr' ? '/fr' : ''}/pricing"
						class="text-gray-600 font-medium text-base">Pricing</a
					>
					<a
						on:click={() => toggleMobileDropdown()}
						href="{data.lang == 'fr' ? '/fr' : ''}/essentials"
						class="text-gray-600 font-medium text-base">Essentials</a
					>
					<!-- <a on:click={() => toggleMobileDropdown()} href="{data.lang == 'fr' ? '/fr' : ''}/blog" class="text-gray-500 font-normal text-sm">Blog</a> -->
					<a
						on:click={() => toggleMobileDropdown()}
						href="{data.lang == 'fr' ? '/fr' : ''}/about"
						class="text-gray-600 font-medium text-base">About</a
					>
					<div class="pt-8">
						<Install />
					</div>
				</div>
			</div>
		</nav>
	</header>

	<main class="isolate">
		<div class="relative pt-14">
			<div
				class="absolute inset-x-0 -z-10 transform-gpu overflow-hidden blur-3xl"
				aria-hidden="true"
			>
				<div
					class="relative left-[50%] aspect-[1155/678] w-[80rem] -translate-x-1/4 rotate-[40deg] bg-gradient-to-tr from-tan to-opal opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
					style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
				/>
			</div>

			<slot />
		</div>
	</main>

	<Prompt />
	<Cookies />

	<!-- Footer -->
	<Footer />
</div>
